const routes = [
  {
    path: 'equal-columns-with-flexbox',
    name: 'equal-columns-with-flexbox',
    component: () => import(/* webpackChunkName: "equal-columns-with-flexbox" */ '@/modules/equal-columns-with-flexbox/index.vue'),
    children: [
      {
        path: '',
        name: 'equal-columns-with-flexbox',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/equal-columns-with-flexbox/demo1.vue')
      },
      {
        path: 'demo1',
        name: 'demo1',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/equal-columns-with-flexbox/demo1.vue')
      },
      {
        path: 'code',
        name: 'code',
        component: () => import(/* webpackChunkName: "code" */ '@/modules/equal-columns-with-flexbox/code.vue')
      },
    ]
  },
];

export default routes;